import type {CSSProperties} from 'react';

export const LOADING_OVERLAY_STYLE: CSSProperties = {
  position: 'absolute',
  zIndex: 999,
  top: 0,
  left: 0,
  width: '100%',
  height: '100%',
  backgroundColor: '#ffffff',
};

export const QUERY_CLIENT_STALE_TIME_MS = 1000 * 60 * 60 * 24;
